import { get } from "@insite/client-framework/Services/ApiService";
import { GetQuoteApiParameter } from "@insite/client-framework/Services/QuoteService";
import { QuoteModel } from "@insite/client-framework/Types/ApiModels";

const baseUrl = "/api/v1/";

export function getCustomQuote(parameter: GetQuoteApiParameter) {
    return get<QuoteModel>(`${baseUrl}/customRfq/getQuote/${parameter.quoteId}`);
}

function cleanQuote(quote: any) {
    quote.quoteNumber = quote.erpOrderNumber || quote.webOrderNumber;
    quote.quoteLineCollection = quote.orderLines;
    quote.quoteLineCollection?.forEach((x: any) => {
        x.productInfo = x.product;
    });
    quote.orderDate = quote.orderDate ? new Date(quote.orderDate) : null;
    quote.expirationDate = quote.expirationDate ? new Date(quote.expirationDate) : null;
    quote.cartLines = quote.quoteLineCollection;
    quote.messageCollection?.forEach((message: any) => {
        if (message.createdDate) {
            message.createdDate = new Date(message.createdDate);
        }
    });
}

export async function getCustomQuoteDetail(parameter: GetQuoteApiParameter) {
    const quote = await get<QuoteModel>(`${baseUrl}/customorders/${parameter.quoteId}`, {
        expand: ["orderlines", "shipments"],
        isQuote: true
    } as any);
    cleanQuote(quote);
    return quote;
}
